import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Clock4, ChevronRight } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const absUrl = (u) => (u && u.startsWith("/") ? `${BACKEND_URL}${u}` : u);

export default function OnThisDay({ match }) {
    const navigate = useNavigate();
    if (!match) return null;
    const { item, label } = match;

    return (
        <motion.button
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            onClick={() => navigate(`/results/${item.id}`)}
            data-testid="on-this-day"
            className="group w-full flex items-stretch gap-3 p-3 rounded-2xl border border-app/20 bg-surface-1 hover:bg-surface-2 hover:border-app/40 transition-all text-left"
        >
            <div className="relative w-12 h-16 shrink-0 rounded-lg overflow-hidden border border-app/30 bg-app-2">
                {item.preview_bg ? (
                    <>
                        <img src={absUrl(item.preview_bg)} alt="" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
                        <div className="absolute inset-0 bg-black/40" />
                    </>
                ) : null}
            </div>
            <div className="flex-1 min-w-0 flex flex-col justify-center">
                <div className="flex items-center gap-1.5">
                    <Clock4 className="w-3 h-3 text-app-3" strokeWidth={1.5} />
                    <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-app-3">
                        {label}
                    </span>
                </div>
                <p className="mt-1 font-serif italic text-app text-sm leading-snug line-clamp-2">
                    "{item.feeling}"
                </p>
            </div>
            <ChevronRight className="w-4 h-4 text-app-3 self-center group-hover:text-app transition-colors" strokeWidth={1.5} />
        </motion.button>
    );
}
